<template>
  <div id="moto-history" class="sav-wrapper">
    <Spinner v-if="isLoading"/>
    <Topbar/>
		<div class="sav-container">
      <Header :back="'/moto/' + id" title="Ιστορικό Ασφάλειας" category="moto"/>
      <History v-if="motoData" category="moto" :id="id" :cardHeaders="motoHeaders" :cardData="motoData" />
      <ErrorMsg v-if="errorMsg" :msg="errorMsg"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './../Spinner.vue'
import Topbar from './../Topbar.vue'
import Header from './../Header.vue'
import History from './../History.vue'
import ErrorMsg from './../ErrorMsg.vue'
import motoHeaders from './../../../public/data/db.moto-single-headers.json'

export default {
	props: ['id'],
  components: {
    Spinner,
    Topbar,
    Header,
    History,
    ErrorMsg
  },
  data() {
    return {
      isLoading: true,
      apiUrl : this.$parent.apiUrl,
      motoHeaders: motoHeaders,
      motoData: '',
      errorMsg: ''
    }
	},
	mounted () {
		const vm = this;
    let formData = {
      user: JSON.parse(localStorage.getItem('sav-erp-user')),
      token: this.$cookie.get('sav-erp-token'),
      refreshToken: this.$cookie.get('sav-erp-refresh-token')
    };

    let headers = { 
			headers: {
			'Content-type': 'application/json',
			}
    };

    axios.post(this.apiUrl + '/get/moto/' + this.id + '/history', formData, headers)
      .then(response => {
        vm.isLoading = false;
        if (response.status == 200) {
          this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
          vm.errorMsg = '';
          vm.motoData = response.data.data;
        } else {
					vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
				}
      })
      .catch(error => {
        let response = error.response;
        
        if (!response) {
          vm.errorMsg = "Μη ενεργός server";
        } else {
          if (response.status == 401) {
            localStorage.removeItem('user');    
            vm.$cookie.delete('sav-erp-token');
            vm.$cookie.delete('sav-erp-refresh-token');
            vm.$router.push("/login");
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
        }
        vm.isLoading = false;
      });
    }
}
</script>

<style lang="scss" scoped>
</style>
